<div class="dialog-content-wrapper edit-space-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    @if (!type) {
      <span class="title dialog-title">{{'marketplaces.edit_marketplace_category' | translate}}</span>
    }
    @if (type === 'sub') {
      <span class="title dialog-title">{{'marketplaces.edit_subcategory' | translate}}</span>
    }
    @if (type === 'create_sub') {
      <span class="title dialog-title">{{'marketplaces.add_subcategory' | translate}}</span>
    }
    <button mat-button class="mat-icon-button"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>
<div class="m-0 content">
  <mat-form-field>
    @if (!type) {
      <input matInput [(ngModel)]="name" required (keyup)="error = false">
    }
    @if (type === 'sub' || type === 'create_sub') {
      <input matInput [(ngModel)]="name" required (keyup)="error = false">
    }
  </mat-form-field>
</div>

@if (error && !name) {
  <div class="error">{{'marketplaces.enter_name' | translate}}</div>
}
<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button class="mat-accent mr-16" (click)="saveCat()">{{'main.save' | translate}}</button>
  <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(false)">{{'main.cancel' | translate}}</button>
</div>
</div>
